import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { plainTooltipContentStyles } from './PlainTooltipContent.styles';
import { plainTooltipContentTheme } from './PlainTooltipContent.stylex';
import { Base } from '../Base';
export const PlainTooltipContent = forwardRef(function PlainTooltipContent(props, forwardedRef) {
    const { styles, sx, supportingText, renderCursor, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'PlainTooltipContent',
        styles: [plainTooltipContentStyles, styles],
    });
    return (_jsxs(Base, { ...other, sx: [
            plainTooltipContentTheme,
            globalStyles,
            ...combineStyles('host'),
            sx,
        ], ref: forwardedRef, children: [renderCursor ? renderCursor(getStyles('cursor')) : null, _jsx("div", { ...getStyles('supportingText'), children: supportingText })] }));
});
